import { ReactNode } from 'react';

export enum Category {
    Design = 'Design',
    Engineering = 'Engineering',
    Processes = 'Processes',
}

export type Tech = {
    category: Category;
    icon: ReactNode;
    name: string;
};
